import { findNext, isTop, isBottom } from '../../utils/dropdowns.js';

var FORMAT = {
  9: '[0-9]',
  a: '[A-Za-z]',
  '*': '[A-Za-z0-9]',
  q: "['A-Za-z\xE0\xE8\xEC\xF2\xF9\xC0\xC8\xCC\xD2\xD9\xE1\xE9\xED\xF3\xFA\xFD\xC1\xC9\xCD\xD3\xDA\xDD\xE2\xEA\xEE\xF4\xFB\xC2\xCA\xCE\xD4\xDB\xE3\xF1\xF5\xC3\xD1\xD5\xE4\xEB\xEF\xF6\xFC\xFF\xC4\xCB\xCF\xD6\xDC\u0178\xE7\xC7-]",
  S: '[A-Za-zàèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇ]',
  // only alpha
  s: "['A-Za-z\xE0\xE8\xEC\xF2\xF9\xC0\xC8\xCC\xD2\xD9\xE1\xE9\xED\xF3\xFA\xFD\xC1\xC9\xCD\xD3\xDA\xDD\xE2\xEA\xEE\xF4\xFB\xC2\xCA\xCE\xD4\xDB\xE3\xF1\xF5\xC3\xD1\xD5\xE4\xEB\xEF\xF6\xFC\xFF\xC4\xCB\xCF\xD6\xDC\u0178\xE7\xC7\\s-.]" // with periods

};
/**
 * When the TextInput has a mask, it renders an InputMask from react-input-mask.
 * This does accept a ref prop (inputRef) but it expects it to be a functional ref
 * and does not work with the newer ref object from useRef.
 * Wrapping the object in a function supports it with and without masks.
 */

var wrapRefObjectAsFunctionalRef = function wrapRefObjectAsFunctionalRef(ref) {
  return function (element) {
    if (ref) {
      // eslint-disable-next-line no-param-reassign
      ref.current = element;
    }
  };
};
var buildHandler = function buildHandler(event, items, option, handleChange, setExpanded, toggleExpanded) {
  return {
    Escape: function Escape() {
      return setExpanded(false);
    },
    Enter: toggleExpanded,
    End: function End() {
      return handleChange(event, findNext(items.length, items, 'Up'));
    },
    Home: function Home() {
      return handleChange(event, findNext(-1, items, 'Down'));
    },
    ArrowUp: function ArrowUp() {
      if (option === -1) {
        setExpanded(true);
      } else {
        handleChange(event, isTop(items, option) ? 0 : findNext(option, items, 'Up'));
      }
    },
    ArrowDown: function ArrowDown() {
      setExpanded(true);
      handleChange(event, isBottom(items, option) ? items.length - 1 : findNext(option, items, 'Down'));
    }
  };
};

export { FORMAT, buildHandler, wrapRefObjectAsFunctionalRef };
